import { render, staticRenderFns } from "./promptChangedDialog.vue?vue&type=template&id=78389ce6&"
import script from "./promptChangedDialog.vue?vue&type=script&lang=js&"
export * from "./promptChangedDialog.vue?vue&type=script&lang=js&"
import style0 from "./promptChangedDialog.vue?vue&type=style&index=0&id=78389ce6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78389ce6')) {
      api.createRecord('78389ce6', component.options)
    } else {
      api.reload('78389ce6', component.options)
    }
    module.hot.accept("./promptChangedDialog.vue?vue&type=template&id=78389ce6&", function () {
      api.rerender('78389ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/promptChangedDialog.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/promptChangedDialog.vue
// module id = DtEh
// module chunks = 0